import {
  conditionOptions,
  hvacAgeOptions,
  plumbingAgeOptions,
  HVAC_AGE_COLOR_MAP,
  PLUMBING_AGE_COLOR_MAP,
  type OptionItem,
} from '../config/options';

const labelsFrom = (options: OptionItem[]) =>
  Object.fromEntries(options.filter((o) => o.value !== 'n_a').map((o) => [o.value, o.label]));

const VALUE_LABELS: Record<string, string> = {
  ...labelsFrom(conditionOptions),
  ...labelsFrom(hvacAgeOptions),
  ...labelsFrom(plumbingAgeOptions),
  // PDF/previous-report UI shows N/A; form select label for the same value is "None".
  n_a: 'N/A',
};

// Condition hexes match the PDF legend (needs_attention is amber here, orange on the form).
const VALUE_COLORS: Record<string, string> = {
  good: '#4CAF50',
  needs_attention: '#FFC107',
  requires_service: '#F44336',
  n_a: '#6b7280',
  ...HVAC_AGE_COLOR_MAP,
  ...PLUMBING_AGE_COLOR_MAP,
};

/** Display text (and optional colour) for one answer stored on an inspection report. */
export function formatReportValue(value: unknown): { display: string; color?: string } {
  if (value === true || value === 'true') return { display: 'Yes' };
  if (value === false || value === 'false') return { display: 'No' };
  if (value === null || value === undefined || value === '') return { display: '—' };
  if (typeof value !== 'string') return { display: String(value) };

  const normalizedValue = value.trim().toLowerCase();
  const color = VALUE_COLORS[normalizedValue];
  if (normalizedValue === 'yes') return { display: 'Yes', color };
  if (normalizedValue === 'no') return { display: 'No', color };
  return { display: VALUE_LABELS[normalizedValue] ?? value, color };
}
